import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { I18NextModule } from 'angular-i18next';
import { AuthorizationResponse } from 'src/app/shared/model/authorization.model';
import { EsService } from 'src/app/core/services/es.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { ActivatedRoute } from '@angular/router';
import i18next from 'i18next';

@Component({
  standalone: true,
  selector: 'app-es-detail',
  templateUrl: './es-detail.component.html',
  styleUrls: ['./es-detail.component.scss'],
  imports: [CommonModule, I18NextModule, MatDialogModule, SharedModule]
})
export class EsDetailComponent implements OnInit {
  uuid = '';
  authorization!: AuthorizationResponse;
  showAuthorization = false;
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private esService: EsService
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.route.queryParamMap.subscribe((params) => {
      const id = params.get('id');
      if (id) {
        this.uuid = id;
        this.getAuthorization(id);
      }
    });
  }

  getAuthorization(uuid: string): void {
    this.esService.getESByAuthorizationId(uuid).subscribe({
      next: (resp) => {
        this.authorization = resp;
        this.showAuthorization = true;
        this.loading = false;
      },
      error: () => {
        this.showAuthorization = false;
        this.loading = false;
      }
    });
  }

  getTranslatedReason(reason: string | null | undefined): string {
    if (!reason) {
      return i18next.t('noData');
    }

    switch (reason) {
      case 'MALFUNCTION_MAINTENANCE_ACCIDENT':
        return i18next.t('loanPlatenumber');

      case 'BUSINESS_TRIP':
        return i18next.t('loanDestination');

      default:
        return i18next.t('loanReason');
    }
  }
}
